import { t } from "i18next";

export const CAMPAIGN_ACTIONS = {
  ACTIVE: true,
  DISABLED: false,
};

export const PROMOTION_CAMPAIGN_TYPE = {
  TOP_SALES: "TOP_SALES",
  COMBO_PROMO: "COMBO_PROMO",
  PRODUCT_PROMO: "PRODUCT_PROMO",
  CASH_DISCOUNT: "LOYALTY_CASH",
  ORDER_PROMO: "ORDER_PROMO",
  LUCKY_WHEEL: "LUCKY_WHEEL",
};

export const PROMOTION_CAMPAIGN_STATUS = {
  ALL: "ALL",
  UPCOMING: "UPCOMING",
  ON_GOING: "ON_GOING",
  RECONCILING: "RECONCILING",
  ENDED: "ENDED",
};

export const TABS_KEY = {
  CAMPAIGN_INFO: "campaignInfo",
  RANKING_BOARD: "rankingBoard",
};

export const COMBO_CAMPAIGN = {
  DISCOUNT_MONEY: "DISCOUNT_MONEY",
  GIFT: "GIFT",
  FIXED_PRICE: "FIXED_PRICE",
  DISCOUNT_PRODUCT: "DISCOUNT_PRODUCT",
};

export const CONDITION_PRODUCT_TYPE = {
  CONDITION_PRODUCT: "CONDITION_PRODUCT",
  GIFT_PRODUCT: "GIFT_PRODUCT",
};

export const COMBO_CAMPAIGN_LABEL = {
  [`${COMBO_CAMPAIGN.DISCOUNT_MONEY}`]: t("campaign.combo.comboDiscount"),
  [`${COMBO_CAMPAIGN.GIFT}`]: t("campaign.combo.comboGift"),
  [`${COMBO_CAMPAIGN.FIXED_PRICE}`]: t("campaign.combo.comboFixedPrice"),
  [`${COMBO_CAMPAIGN.DISCOUNT_PRODUCT}`]: "KHUYẾN MÃI 1 SẢN PHẨM",
};

export const DISCOUNT_TYPE = {
  DISCOUNT_MONEY: "DISCOUNT_MONEY",
  DISCOUNT_PERCENTAGE: "DISCOUNT_PERCENTAGE",
};

export const DISCOUNT_TYPE_LABEL = {
  [`${DISCOUNT_TYPE.DISCOUNT_MONEY}`]: t("campaign.combo.discountMoney"),
  [`${DISCOUNT_TYPE.DISCOUNT_PERCENTAGE}`]: t("campaign.combo.discountPercent"),
};

export const OPTIONS_TYPE_DISCOUNT = [
  { value: DISCOUNT_TYPE.DISCOUNT_MONEY, label: t("campaign.combo.discountMoney") },
  { value: DISCOUNT_TYPE.DISCOUNT_PERCENTAGE, label: t("campaign.combo.discountPercent") },
];

export const TYPE_LIMIT = {
  LIMIT: "LIMITED",
  NO_LIMIT: "UNLIMITED",
};

export const OPTIONS_TYPE_LIMIT = [
  { value: TYPE_LIMIT.LIMIT, label: t("campaign.combo.limit") },
  { value: TYPE_LIMIT.NO_LIMIT, label: t("campaign.combo.noLimit") },
];

export const PRODUCT_TYPE = {
  CONDITION_PRODUCT: "CONDITION_PRODUCT",
  GIFT_PRODUCT: "GIFT_PRODUCT",
};

export const SORT_TYPES = {
  ascend: "ASC",
  descend: "DESC",
};

export const convertOrderSortBy = {
  deliveryDeadline: "DELIVER_DEADLINE",
  createdAt: "CREATED_AT",
};

export const CAMPAIGN_TYPE = {
  COMBO_PROMO: "COMBO_PROMO",
  PRODUCT_PROMO: "PRODUCT_PROMO",
  CASH_DISCOUNT: "LOYALTY_CASH",
  TOP_SALES: "TOP_SALES",
  ORDER_PROMO: "ORDER_PROMO",
  LUCKY_WHEEL: "LUCKY_WHEEL",
};

export const SELLER_USER_SEGMENT_TYPE = {
  ALL: "ALL",
  NO_ORDER: "NO_ORDER",
  NOT_PURCHASED_PRODUCT: "NOT_PURCHASED_PRODUCT",
};

export const PRODUCT_PROMO_TARGET_CUSTOMER_OPTIONS = [
  { value: SELLER_USER_SEGMENT_TYPE.ALL, label: "Tất cả đại lý" },
  { value: SELLER_USER_SEGMENT_TYPE.NO_ORDER, label: "Đại lý chưa từng phát sinh đơn hàng" },
  { value: SELLER_USER_SEGMENT_TYPE.NOT_PURCHASED_PRODUCT, label: "Đại lý chưa từng mua các sản phẩm này" },
];

export const PRODUCT_PROMO_SEGMENT_TYPES_WITH_PROGRAM_BUDGET = [
  SELLER_USER_SEGMENT_TYPE.NO_ORDER,
  SELLER_USER_SEGMENT_TYPE.NOT_PURCHASED_PRODUCT,
];

export const isProductPromoProgramBudgetRequired = (segmentType) =>
  PRODUCT_PROMO_SEGMENT_TYPES_WITH_PROGRAM_BUDGET.includes(segmentType);
